export default {
  paged: {
    select: 'id,name,description,isActive',
    searchSelect: ['name', 'description'],
    orderBy: 'name',
  },
  item: {
    select: 'id,name,description,isActive',
  },
  itemDetail: {
    select: 'id,name,description,isActive,creator,modifier,created,updated',
  },
};
